<template>
  <p
    class="bg-static-default-mid text-static-default-hi rounded-full text-caption flex flex-row items-center px-8 py-4 leading-none"
  >
    <component :is="icon" class="mr-4" size="16" />
    <span>{{ text }}</span>
  </p>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{ text: string; icon: Component }>()
</script>
